





















































































































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import ListBase from '@/lib/listbase';
import PageRequest from '@/store/entities/page-request';
import VWidget from '@/components/VWidget.vue';
import profileMenu from '@/components/shrinkable-menu/profile-menu.vue';
import CancelBooking from './cancel-booking.vue';
import ImageModal from '@/components/image.vue';
import Util from '@/lib/util';

class PageOrderRequest extends PageRequest {
}

@Component({
    components: { ModalView, profileMenu, CancelBooking, VWidget, ImageModal },
    watch: {
        mainAddress: function (val, oldVal) {
            let obj = (this as any);
            if (oldVal != null && val != null) {
                obj.changeMain(obj.list[val].id_address)
            }
        },
    }
})

export default class OrderProductView extends ListBase {
    showCancel: boolean = false;
    file: any = null;
    uploadImage: string = null;
    imgModalShow: boolean = false;
    pState: any = Util.abp.list.getCodeList('E_BOOKING');

    get booking() {
        return this.$store.state.booking.viewModel;
    }
    get loading() {
        return this.$store.state.booking.loading;
    }
    get uploading() {
        return this.$store.state.booking.uploading;
    }
    get capture() {
        let url = null;
        if (this.uploadImage != null) url = this.uploadImage;
        else if (this.booking != null && this.booking.payments != null && this.booking.payments.length > 0) {
            if (this.booking.payments[0].capture_url != null)
                url = this.booking.payments[0].capture_url;
        }
        return url;
    }
    get requireDoc() {
        let res = false;
        if (this.booking.payment_gateway != null) {
            let conf = Util.abp.setting.get(this.booking.payment_gateway.code + '_PAYMENT_METHOD');
            if (conf != null) {
                let meth = Util.getEntity(this, 'paymentmethod', conf);
                if (meth != null)
                    res = meth.require_document == true;
            }
        }
        return res;
    }
    get currencySign() {
        if (this.booking.currency == null)
            return Util.abp.setting.get('DEFAULT_CURRENCY_SIGN');
        return this.booking.currency.sign;            
    }
    get products() {
        return this.booking.products;
    }

    getMethodIcon(brand: string) {
        if (brand != undefined) {
            brand = brand.toLowerCase();
            return require('../../../assets/img/cards/' + brand + '.png');
        } else
            return '';
    }

    async uploadFile() {
        if (this.file == null) return;
        let formData = new FormData();
        formData.append('sale', this.booking.id);
        formData.append('file', this.file);

        this.uploadImage = await this.$store.dispatch({
            type: 'booking/uploadVoucher',
            data: formData
        });

        Util.abp.notify.success(this, 'Hemos subido tu imagen!');
        (this.$refs.fileInput as any).reset();
    }

    back() {
        Util.toRoute(this, 'book');
    }

    cancelBook() {
        this.showCancel = !this.showCancel;
    }


    async mounted() {
        if (this.$route.params.id != undefined) {
            let booking = await this.$store.dispatch({
                type: 'booking/get',
                id: this.$route.params.id
            });
            this.$store.commit('booking/view', booking);
        }
    }

    created() {
    }
}
